import {Grid, styled} from '@material-ui/core';

export const RowField = styled(Grid)({
  '& .MuiFormControl-root': {
    minHeight: 'auto'
  }
});
